import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button'; 

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
// mock
import EditarEmpresaForm from '../FormsTemplates/Empresa/EditarEmpresaForms';

export default function AlterarEmpresa() {
  
  return (
    <Page title="Empresa">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Alterar Empresa
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/empresas/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <EditarEmpresaForm/>    
      </Container>
    </Page>
  );
}
